/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why top up to volume after mixing?`)
};

const es_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué completar hasta el volumen tras mezclar?`)
};

const de_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum nach dem Mischen auf Volumen auffüllen?`)
};

const nl_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom na het mengen aanvullen tot volume?`)
};

const fr_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi compléter au volume après le mélange ?`)
};

const it_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché portare a volume dopo aver mescolato?`)
};

const pt_br2_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que completar o volume após misturar?`)
};

const pt_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê completar até ao volume depois de misturar?`)
};

const ja_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合後に量を調整するのはなぜですか?`)
};

const zh_buf_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么混合后还要定容？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_q2", locale)
	if (locale === "en") return en_buf_faq_q2(inputs)
	if (locale === "es") return es_buf_faq_q2(inputs)
	if (locale === "de") return de_buf_faq_q2(inputs)
	if (locale === "nl") return nl_buf_faq_q2(inputs)
	if (locale === "fr") return fr_buf_faq_q2(inputs)
	if (locale === "it") return it_buf_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_q2(inputs)
	if (locale === "pt") return pt_buf_faq_q2(inputs)
	if (locale === "ja") return ja_buf_faq_q2(inputs)
	return zh_buf_faq_q2(inputs)
};